
import { useBoolean } from "src/hooks/use-boolean";

import { api } from "src/utils/axios";

import { useMyInterestsStore } from "src/stores/my-interests/my-interests.store";
import { MyInterestsRepository } from "src/repositories/my-interests/my-interests.repository";

export const useMyInterestDialog = () => {
  const startQuiz = useBoolean(false)
  const sendingMyInterests = useBoolean(false)

  const setUseMyInterestsDialog = useMyInterestsStore((state) => state.setUseMyInterestsDialog)

  const repository = new MyInterestsRepository(api)

  const handleCloseDialog = () => {
    setUseMyInterestsDialog(false)
    repository.maybeLater()
  }

  return {
    startQuiz,
    sendingMyInterests,
    handleCloseDialog,
  }
};
